<template>
    <article
        v-click-outside="onClickOutside"
        class="pf-simple-select"
        :class="{disabled: selectData.values?.length <= 1 || disabled}">
        <input
            class="visually-hidden"
            type="text"
            :name="fieldName"
            v-model="value">
        <div
            class="pf-simple-select__label"
            v-html="label"></div>
        <div
            v-if="tooltip"
            class="pf-simple-select__tooltip">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none">
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M0.583984 6.99996C0.583984 3.45613 3.45682 0.583293 7.00065 0.583293C10.5445 0.583293 13.4173 3.45613 13.4173 6.99996C13.4173 10.5438 10.5445 13.4166 7.00065 13.4166C3.45682 13.4166 0.583984 10.5438 0.583984 6.99996ZM12.2506 6.99995C12.2506 4.10045 9.90014 1.74995 7.00064 1.74995C4.10115 1.74995 1.75064 4.10045 1.75064 6.99995C1.75064 9.89944 4.10115 12.2499 7.00064 12.2499C9.90014 12.2499 12.2506 9.89944 12.2506 6.99995ZM6.41732 9.33329V6.99996C6.41732 6.67779 6.67849 6.41663 7.00066 6.41663C7.32282 6.41663 7.58399 6.67779 7.58399 6.99996V9.33329C7.58399 9.65546 7.32282 9.91663 7.00066 9.91663C6.67849 9.91663 6.41732 9.65546 6.41732 9.33329ZM7.41314 5.66245C7.64094 5.43464 7.64094 5.0653 7.41314 4.83749C7.18533 4.60968 6.81598 4.60968 6.58818 4.83749C6.36037 5.0653 6.36037 5.43464 6.58818 5.66245C6.81598 5.89026 7.18533 5.89026 7.41314 5.66245Z"
                    fill="#6D6D6D"/>
            </svg>
            <div
                class="pf-simple-select__tooltip-text"
                v-html="tooltip"></div>
        </div>
        <button
            class="pf-simple-select__trigger"
            :class="{active: listVisible, hasValue: value}"
            @click.prevent="showListItems">
            <span
                class="pf-simple-select__output"
                v-html="outputText"></span>
            <button
                v-if="value"
                class="pf-simple-select__clear clear-btn"
                @click.prevent.stop="clearField"></button>
        </button>
        <ul
            v-show="listVisible"
            class="pf-simple-select__list">
            <li
                v-for="(item, i) in getData"
                :key="i"
                class="pf-simple-select__item-wrap">
                <button
                    class="pf-simple-select__item"
                    @click.prevent="chooseItem(item[1], item[0], i)"
                    v-html="item[1]"></button>
            </li>
        </ul>
    </article>
</template>

<script>
    import vClickOutside from 'click-outside-vue3'
    export default {
        name: 'SimpleSelect',
        props: {
            selectData: {
                type: Array,
                default: []
            },
            placeholder: {
                type: String,
                default: ''
            },
            label: {
                type: String,
                default: ''
            },
            tooltip: {
                type: String,
                default: ''
            },
            fieldName: {
                type: String,
                default: ''
            },
            onloadValue: {
                type: String,
                default: ''
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                listVisible: false,
                outputText: '',
                value: ''
            }
        },
        computed: {
            getData() {
                if (this.selectData.values[110]) {
                    let sortedArr = []
                    Object.entries(this.selectData.values).forEach((el, i) => {
                        if (el[0] == 110) {
                            sortedArr[Object.entries(this.selectData.values).length - 1] = el
                        } else {
                            sortedArr[i - 1] = el 
                        }
                    })
                    return sortedArr
                }
                
                return Object.entries(this.selectData.values)
            },
        },
        methods: {
            showListItems () {
                if (this.listVisible) {
                    this.listVisible = false
                    return
                }

                this.listVisible = true
            },

            chooseItem (item, name, index) {
                this.listVisible = false
                this.value = name
                this.outputText = item

                this.$emit('selectChoosen', this.fieldName, this.value)
            },

            onClickOutside () {
                if (this.listVisible) {
                    this.listVisible = false
                }
            },

            clearField () {
                this.value = ''
                this.outputText = this.placeholder

                this.$emit('selectChoosen', this.fieldName, this.value)
            }
        },
        
        directives: {
            clickOutside: vClickOutside.directive
        },

        watch: {
            'disabled'(newVal) {
                this.clearField()
            }
        },

        created() {
            if (this.onloadValue) {
                this.value = this.onloadValue
                this.outputText = this.selectData.values[this.onloadValue]
                return
            }

            this.outputText = this.placeholder
        }
    }
</script>